type MobileTheme = "Green" | "Gray" | "Yellow" | "Blue" | "Red" | "Orange";

export default MobileTheme;

export const MobileThemeOptions = ["Green", "Gray", "Yellow", "Blue", "Red", "Orange"];